<div class="panel_wrapper">
  <div class="pb-4 text-center">
    <span class="warning">{{message | translate}}</span>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <button class="create_btn w_45 mt-0" (click)="createNew()">{{ 'VENUE.ADD_NEW' | translate}}</button>
    <button class="btn_cancel_no_border w_45" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  </div>
</div>
